(function () {
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function formatMoney(cents, fmt) {
    var n = (cents / 100).toFixed(2);
    var out = (fmt || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount') return n;
      if (k === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return n.replace('.', ',');
    });
    var t = document.createElement('textarea'); t.innerHTML = out; return t.value;
  }

  function init(root) {
    if (!root || root.dataset.mn3Init) return;
    root.dataset.mn3Init = '1';
    var jsonEl = root.querySelector('[data-mn3-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var fmt = root.getAttribute('data-money-format');
    var form = root.querySelector('form[data-mn3-form]');
    var idInput = root.querySelector('[data-mn3-variant-id]');
    var atc = root.querySelector('[data-mn3-atc]');
    var err = root.querySelector('[data-mn3-err]');
    var stock = root.querySelector('[data-mn3-stock]');
    var priceEls = $$(root, '[data-mn3-price]');
    var slides = $$(root, '[data-mn3-slide]');
    var thumbs = $$(root, '[data-mn3-thumb]');
    var dots = $$(root, '[data-mn3-dot]');
    var count = root.querySelector('[data-mn3-count]');
    var opts = $$(root, '[data-mn3-opt]');
    var gi = 0;

    function show(i) {
      if (!slides.length) return;
      gi = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === gi); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === gi); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === gi); });
      if (count) count.textContent = (gi + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-mn3-prev]'), next = root.querySelector('[data-mn3-next]');
    if (prev) prev.addEventListener('click', function () { show(gi - 1); });
    if (next) next.addEventListener('click', function () { show(gi + 1); });

    var start = data.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || data.variants[0];
    var selected = start.options.slice();
    function find(sel) { return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]; }

    function update(fromUser) {
      var v = find(selected);
      opts.forEach(function (fs) {
        var pos = parseInt(fs.getAttribute('data-mn3-opt'), 10) - 1;
        $$(fs, '[data-value]').forEach(function (b) {
          var on = b.getAttribute('data-value') === selected[pos];
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          var test = selected.slice(); test[pos] = b.getAttribute('data-value');
          var tv = find(test);
          b.classList.toggle('is-out', !tv || !tv.available);
        });
        var lab = fs.querySelector('[data-mn3-opt-value]');
        if (lab) lab.textContent = selected[pos];
      });
      if (err) err.hidden = true;
      if (!v) {
        atc.disabled = true; atc.textContent = 'Nicht verfügbar';
        if (stock) { stock.textContent = 'Diese Kombination gibt es nicht'; stock.classList.add('is-out'); }
        return;
      }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (stock) {
        stock.textContent = v.available ? stock.getAttribute('data-in') : 'Ausverkauft';
        stock.classList.toggle('is-out', !v.available);
      }
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      priceEls.forEach(function (p) {
        p.classList.toggle('is-sale', !!sale);
        p.innerHTML = '';
        p.appendChild(document.createTextNode(formatMoney(v.price, fmt)));
        if (sale) { var s = document.createElement('s'); s.textContent = formatMoney(v.compare_at_price, fmt); p.appendChild(document.createTextNode(' ')); p.appendChild(s); }
      });
      if (fromUser && v.featured_media) {
        slides.forEach(function (s, k) { if (String(s.getAttribute('data-media-id')) === String(v.featured_media.id)) show(k); });
      }
      if (fromUser && window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }
    opts.forEach(function (fs) {
      var pos = parseInt(fs.getAttribute('data-mn3-opt'), 10) - 1;
      $$(fs, '[data-value]').forEach(function (b) {
        b.addEventListener('click', function () { selected[pos] = b.getAttribute('data-value'); update(true); });
      });
    });
    update(false);

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      var drawer = document.querySelector('cart-drawer');
      var sections = [];
      try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (x) {}
      var root2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      atc.disabled = true;
      var label = atc.textContent; atc.textContent = 'Wird hinzugefügt …';
      fetch(root2 + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (state) {
        atc.disabled = false; atc.textContent = label;
        if (state && state.status) { if (err) { err.textContent = state.description || 'Das hat nicht geklappt.'; err.hidden = false; } return; }
        try {
          if (drawer && drawer.renderContents && state.sections) { drawer.renderContents(state); return; }
        } catch (x) {}
        window.location.href = root2 + 'cart';
      }).catch(function () { atc.disabled = false; atc.textContent = label; form.submit(); });
    });

    var sticky = root.querySelector('[data-mn3-sticky]');
    var stickyBtn = root.querySelector('[data-mn3-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { atc.click(); });
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; });
      }).observe(atc);
    }

    var dialog = root.querySelector('[data-mn3-guide]');
    $$(root, '[data-mn3-guide-open]').forEach(function (b) { b.addEventListener('click', function () { if (dialog && dialog.showModal) dialog.showModal(); }); });
    $$(root, '[data-mn3-guide-close]').forEach(function (b) { b.addEventListener('click', function () { if (dialog) dialog.close(); }); });
    if (dialog) dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  function boot(scope) { $$(scope || document, '[data-mn3-product-page]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
